/* 🤖 this file was generated by svg-to-ts */
export const mgcIconNewdotFilled: {
  name: 'newdot-filled';
  data: string;
} = {
  name: 'newdot-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.58 3.047c-.733.14-1.4.821-1.537 1.57-.061.334-.061 14.432 0 14.766.141.768.806 1.433 1.574 1.574.334.061 14.432.061 14.766 0 .768-.141 1.433-.806 1.574-1.574.029-.162.043-1.791.043-5.136V9.349l-.308.31a4.457 4.457 0 0 1-4.621 1.1 4.364 4.364 0 0 1-1.737-1.077 4.47 4.47 0 0 1 .007-6.374l.31-.308-4.935.004c-2.936.003-5.017.02-5.136.043m12.38 1.015c-.418.089-.891.352-1.219.677a2.477 2.477 0 0 0 0 3.52c.968.968 2.535.978 3.495.022.465-.462.71-.999.751-1.641.102-1.631-1.414-2.923-3.027-2.578"/></svg>`
};
